export const fetchFaq = jsonFetch => () => {
  const route = `/faq`;
  return jsonFetch(route);
};
